<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="订单编号" prop="orderNo">
                <a-input v-model="queryParam.orderNo" placeholder="请输入订单编号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="买家昵称" prop="buyerId">
                <a-input v-model="queryParam.buyeName" placeholder="请输入买家昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="订单付款时间" prop="payTime">
                <a-date-picker style="width: 100%" v-model="queryParam.payTime" @change="changezhifu" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="外部交易号" prop="outTradeNo">-->
<!--                <a-input v-model="queryParam.outTradeNo" placeholder="请输入外部交易号" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">

              <a-col :md="8" :sm="24">
                <a-form-item label="订单完成时间" prop="finishTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.finishTime" @change="changeSuccess" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最后付款时间" prop="lastPayTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.lastPayTime" @change="changezuihou" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['distribution:vip/order:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['distribution:vip/order:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['distribution:vip/order:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['distribution:vip/order:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
<!--        <table-setting-->
<!--          :style="{float: 'right'}"-->
<!--          :table-size.sync="tableSize"-->
<!--          v-model="columns"-->
<!--          :refresh-loading="loading"-->
<!--          @refresh="getList" />-->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="finishTime" slot-scope="text, record">
          {{ parseTime(record.finishTime) }}
        </span>
        <span slot="lastPayTime" slot-scope="text, record">
          {{ parseTime(record.lastPayTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['distribution:vip/order:edit']" />-->
<!--          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['distribution:vip/order:edit']">-->
<!--            <a-icon type="edit" />-->
<!--            编辑-->
<!--          </a>-->
<!--          <a-divider type="vertical" v-hasPermi="['distribution:vip/order:remove']" />-->
          <a @click="handleDelete(record)" v-hasPermi="['distribution:vip/order:remove']">
<!--            <a-icon type="delete" />-->
            删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageVipOrder,listVipOrder, delVipOrder } from '@/api/distribution/vipOrder'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'VipOrder',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        orderNo: null,
        outTradeNo: null,
        paymentType: null,
        buyeName: null,
        orderMoney: null,
        payMoney: null,
        orderStatus: null,
        payTime: null,
        finishTime: null,
        lastPayTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          align: 'center',
          width: 60,
          customRender: function (text, record, index) {
            return (index + 1)
          }
        },


        {
          title: '订单编号',
          dataIndex: 'orderNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '外部交易号',
          dataIndex: 'outTradeNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '支付类型',
          dataIndex: 'paymentType',
          ellipsis: true,
          align: 'center',
          customRender: function (text) {
            if(text == 1) {
              return '余额'
            } else if(text == 2) {
              return '微信'
            } else if(text == 3) {
              return '积分'
            }
          }
        },
        {
          title: '买家',
          dataIndex: 'buyeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单总价',
          dataIndex: 'orderMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单实付金额',
          dataIndex: 'payMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          ellipsis: true,
          align: 'center',
          customRender(text) {
            if(text == 1) {
              return '待付款'
            } else if(text == 2) {
              return '已完成'
            } else if(text == 0) {
              return '已取消'
            }
          }
        },
        {
          title: '订单付款时间',
          dataIndex: 'payTime',
          scopedSlots: { customRender: 'payTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单完成时间',
          dataIndex: 'finishTime',
          scopedSlots: { customRender: 'finishTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后付款时间',
          dataIndex: 'lastPayTime',
          scopedSlots: { customRender: 'lastPayTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '插入时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    changeSuccess(value,str) {
      console.log(value)
      console.log(str)
      this.queryParam.finishTime = str;
    },

    changezuihou(value,str) {
      console.log(value)
      console.log(str)
      this.queryParam.lastPayTime = str
    },

    changezhifu(value,str) {
      console.log(value)
      console.log(str)
      this.queryParam.payTime = str
    },
    /** 查询创业vip开通订单列表 */
    getList () {
      this.loading = true
     pageVipOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        orderNo: undefined,
        outTradeNo: undefined,
        paymentType: undefined,
        buyeName: undefined,
        orderMoney: undefined,
        payMoney: undefined,
        orderStatus: undefined,
        payTime: undefined,
        finishTime: undefined,
        lastPayTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delVipOrder(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('distribution/vip/order/export', {
            ...that.queryParam
          }, `创业vip开通订单_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
